import './CameraPermissionDialog.scss'
import React from 'react';
import { 
	IonIcon,
	IonButton, 
	IonModal, 
	IonContent, 
	IonToolbar, 
	IonButtons, 
	IonHeader 
} from '@ionic/react';
import { OpenNativeSettings } from '@ionic-native/open-native-settings';
import { qrCode, alertCircleSharp, chevronBackOutline } from 'ionicons/icons';

interface Props {
	isOpen: boolean;
	setIsOpen: any;
}

const CameraPermissionDialog: React.FC<Props> = ({
	isOpen,
	setIsOpen,
}) => {
	return (
		<IonModal isOpen={isOpen} className="camera-permission-modal">
			<IonHeader className="bg-dark">
				<IonToolbar className="bg-dark p-x-16 p-y-10">
					<IonButtons slot="start" onClick={() => {
						setIsOpen(false);
					}}>
						<IonIcon icon={chevronBackOutline} />
					</IonButtons>
				</IonToolbar>
			</IonHeader>
			<IonContent className="bg-dark">
				<div className="camera-permission-disabled">
					<IonIcon icon={qrCode} className="camera-disabled" />
					<IonIcon icon={alertCircleSharp} className="alert" />
					<p className="title">You’ve disabled access to your camera.</p>
					<p className="content">If you’d like to use qrcode scanner, you can change this permission in your device’s Settings.</p>
					<IonButton
						onClick={() => { OpenNativeSettings.open('application_details') }}
						expand="block"
						color="none"
						shape="round"
						className="btn-transparent wide">
						Go to Settings
					</IonButton>
				</div>
			</IonContent>
		</IonModal>
	);
};

export default CameraPermissionDialog;